import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AdminStore {
  adminToken: string | null;
  setAdminToken(token: string): void;
  clearAdminToken(): void;
}

export const useAdminStore = create<AdminStore>()(
  persist(
    (set) => ({
      adminToken: null,
      setAdminToken: (token) => set({ adminToken: token }),
      clearAdminToken: () => set({ adminToken: null }),
    }),
    { name: 'playground-admin' },
  ),
);
